import axios from 'axios';

export const DEFAULT_GOOGLE_ALERT_RELEVANCE_PROMPT = `You are a credit-risk analyst reviewing Google Alert news items for portfolio company "{{companyName}}".{{contextBlock}}

Each item includes matchedQuery (the Google Alert keyword). Use company name, disambiguation context, and matchedQuery together.

For each item, decide:
- isAboutCustomer: true only if the article is directly about THIS portfolio company (named or unmistakably this firm). False for generic industry or regulatory news that does not name the company.
- isMaterial: true if a credit / revenue-based financing provider watching THIS company should see it. Set true for material company news and for industry, regulatory, or market developments that plausibly affect this company's business per disambiguation context—even when the company is not named. Material categories include: {{categories}}. False for namesakes, job boards, directory pages, unrelated firms, and noise with no plausible impact on this company.
- category: short label (e.g. funding, regulatory).
- whyItMatters: one sentence for Slack; explain relevance to this portfolio company (name the company when the article does not).
- confidence: 0.0 to 1.0 for isMaterial (and direct-company match when isAboutCustomer is true).
- storyGroupId: assign the same positive integer when two or more items describe the same underlying news event (e.g. CNN and Fox covering the same funding round). Use different ids for unrelated events. Base this only on title, snippet, and URL in the batch.

Return one result row per input index.`;

export const DEFAULT_GOOGLE_ALERT_SUMMARY_PROMPT = `Fetch {{url}} and write a 2-4 sentence summary of what the article says, plus one sentence on why it matters to {{companyName}}. The article title is: {{title}}. If the page cannot be retrieved, say so explicitly instead of guessing from the title.`;

export const DEFAULT_GOOGLE_ALERT_CATEGORIES =
  'funding, M&A, layoffs, lawsuits/regulatory, exec changes, insolvency, major negative press';

export const getLatestGoogleAlertRelevancePromptConfig = async () =>
  (await axios.get('admin/google-alert-relevance-prompt-config/latest')).data;

export const listGoogleAlertRelevancePromptConfigVersions = async () =>
  (await axios.get('admin/google-alert-relevance-prompt-config/versions')).data;

export const getGoogleAlertRelevancePromptConfigVersion = async (version) =>
  (await axios.get(`admin/google-alert-relevance-prompt-config/versions/${version}`)).data;

export const createGoogleAlertRelevancePromptConfigVersion = async (body) =>
  (await axios.post('admin/google-alert-relevance-prompt-config', body)).data;
